export default __webpack_public_path__ + "static/media/gallery_06.f4f02b43.jpg";